import Vue from 'vue'
import Vuex from 'vuex'
// import { login, logout, getTokenApi, modifyPassword,  sendCode, bindLogin } from '@/api'
import { registerSendCode, pwdLogin, loginSendCode, codeLogin, changePwdSendCode, getUserInfo } from '@/api/api.js'
import { getToken, setToken, removeToken } from '@/utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: getToken(),
    name: '',
    uuid: '',
    user_type: '',
    user: {},
    userInfo: {}
  },
  getters: {
    token: state => state.token,
    // roles: state => state.user.roles,
    // user_type: state => {
    //     return state.user ? state.user.user_type : null;
    // },
    // user: state => state.user.user,
    uuid: state => state.uuid,
    userInfo: state => state.userInfo
  },
  mutations: {
    SET_TOKEN (state, token) {
      state.token = token
    },
    SET_UUID (state, uuid) {
      state.uuid = uuid
    },
    // [types.SET_ROLES]: (state, roles) => {
    //     state.roles = roles
    // },
    // [types.SET_USER]: (state, user) => {
    //     state.user = user
    // },
    SET_UserInfo (state, userInfo) {
      state.userInfo = userInfo
    }
  },
  actions: {
    // 发送验证码
    sendCode ({ commit }, params) {
      return new Promise((resolve, reject) => {
        registerSendCode(params).then(res => {
          if (res.status === 200) {
            resolve()
          } else {
            reject(res.message)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    lSendCode ({ commit }, params) {
      return new Promise((resolve, reject) => {
        loginSendCode(params).then(res => {
          if (res.status === 200) {
            resolve()
          } else {
            reject(res.message)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    cpSendCode ({ commit }, params) {
      return new Promise((resolve, reject) => {
        changePwdSendCode(params).then(res => {
          if (res.status === 200) {
            resolve()
          } else {
            reject(res.message)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // user login
    login ({ dispatch, commit }, userInfo) {
      const loginCodeType = userInfo.loginCodeType // loginCodeType 其他登录方式显示类型  1密码登录、2验证登录
      let data, requests
      if (loginCodeType == 1) {
        data = { username: userInfo.username, password: userInfo.password }
        requests = pwdLogin
      } else {
        data = { phone: userInfo.phone, code: userInfo.code }
        requests = codeLogin
      }
      return new Promise((resolve, reject) => {
        requests(data).then(res => {
          if (res.status == 200) {
            dispatch('getTokenHandle', res.body).then(() => {
              // router.replace({ path: '/' })
            })
            dispatch('getUserInfo', res.body).then(() => {
              // router.replace({ path: '/' })
            })
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // // user logout
    logout ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        sessionStorage.removeItem('userInfo')
        removeToken()
        resolve()
      })
    },

    // // 获取权限信息
    // getRole({ commit, state }) {
    //     return new Promise((resolve, reject) => {
    //         getRoleApi().then(res => {
    //             const { user, authority } = res.body
    //             const roles = []
    //             if (authority.length) {
    //                 for (const item of authority) {
    //                     roles.push(item.controlName)
    //                 }
    //             }
    //             commit(types.SET_USER, user)
    //             commit(types.SET_ROLES, roles)
    //             commit(types.SET_USERTYPE, user.type)
    //             resolve({ roles: roles, type: user.type })

    //         }).catch(error => {
    //             reject(error)
    //         })
    //     })
    // },

    // // 修改密码
    // modifyPassword({ dispatch }, form) {
    //     const { oldPassword, newPassword } = form
    //     return new Promise((resolve, reject) => {
    //         modifyPassword({ oldPassword, newPassword }).then((res) => {
    //             resolve(res)
    //         }).catch(error => {
    //             reject(error)
    //         })
    //     })
    // },

    // 获取token
    getTokenHandle ({ commit }, params) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', params)
        setToken('basic ' + params)
        resolve()
      })
    },

    // // remove token
    resetToken ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },

    // 设置uuid
    setUuid ({ commit }, uuid) {
      return new Promise(resolve => {
        commit('SET_UUID', uuid)
        resolve()
      })
    },

    // 获取基础信息
    getUserInfo ({ dispatch, commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          //console.log(res.body, 'getUserInfo')

          if (res.status == 200) {
            sessionStorage.setItem('userInfo', JSON.stringify(res.body))
            commit('SET_UserInfo', res.body)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    }

  }
})
